import React from 'react'

function AdminFooter() {
  return (
    <div className='admin-footer'>Copyright &#169; 2023 ASRAM</div>
  )
}

export default AdminFooter;